import React, { useContext } from 'react'
import { BuildingDown, Calendar2DateFill, Clipboard2Check, Key, LayoutTextWindow, Mailbox, MenuUp, NodePlus, PenFill, People, PeopleFill, PersonFill } from 'react-bootstrap-icons'
import { NavLink } from 'react-router-dom'
import Authentication from '../../../../../libs/api/services/Authentication'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'

export default function DashboardContainer({ Icon, title, description, location, reference, access }) {
    const { GlobalRef } = useContext(CommonFunctionsContext)
    const ICON = (icon) => {
        switch (icon) {
            case 'messaging': return <MenuUp size={50} />
            case 'automation': return <NodePlus size={50} />
            case 'user': return <People size={50} />
            case 'add-user': return <PersonFill size={50} />
            case 'facility': return <BuildingDown size={50} />
            case 'email': return <Mailbox size={50} />
            case 'template': return <LayoutTextWindow size={50} />
            case 'calendar': return <Calendar2DateFill size={50} />
            case 'todo': return <Clipboard2Check size={50} />
            case 'tnc': return <PenFill size={50} />
            case 'access': return <Key size={50} />
            case 'teams': return <PeopleFill size={50} />
            default: return <></>
        }
    }

    return (
        <AccessComponent access={access}>
            <div className='col-12 col-lg-4 '>
                <NavLink
                    ref={r => reference && GlobalRef(r, reference)}
                    to={location}
                    className='bg-primary-container d-flex flex-column  h-100 p-3 rounded mx-2'>

                    <div>{ICON(Icon)}</div>
                    <div><b>{title}</b></div>
                    <div><p className='pt-2'>{description}</p></div>
                </NavLink>
            </div>
        </AccessComponent>
    )
}

const AccessComponent = ({ access, children }) => {
    // const _handleAccess = () =>
    //     access && !Authentication.isClaimValid()
    const validateAccess = () => {
        if (access) {
            for (var i = 0; i < access.length; i++)
                if (Authentication.isClaimValid(access[i])) return children
            return <></>
        }
        return children
    }
    return validateAccess();

}